var _excluded = ["children", "duration", "maxSize", "optionsFn", "pauseOnMouseEnter", "pauseOnWindowBlur", "placement", "portal", "portalContent", "resumeOnMouseLeave", "resumeOnWindowFocus"];

var _jsxFileName = "/Users/krise/gitlab/drywall/src/components/Toast/ToastProvider.jsx",
    _this = this;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ToastQueue from '../../js/ToastQueue';
import AnimatedList from '../AnimatedList/AnimatedList';
export var ToastContext = /*#__PURE__*/React.createContext();
export var withToast = function withToast(Component) {
  var WithToast = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(ToastContext.Consumer, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12,
        columnNumber: 9
      }
    }, function (context) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, context, {
        ref: ref,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 13,
          columnNumber: 25
        }
      }));
    });
  });
  WithToast.displayName = "WithToast(" + (Component.diplayName || Component.name || 'Component') + ")";
  return WithToast;
};

var ToastProviderClass = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ToastProviderClass, _React$Component);

  function ToastProviderClass(props) {
    var _this2;

    _this2 = _React$Component.call(this, props) || this;

    _this2.onWindowFocus = function () {
      _this2.queue.resumeAll();
    };

    _this2.onWindowBlur = function () {
      _this2.queue.pauseAll();
    };

    _this2.onQueueChange = function () {
      _this2.setState({
        toasts: _this2.queue.getState()
      });
    };

    _this2.getContext = function () {
      return {
        enqueueToast: _this2.enqueueToast
      };
    };

    _this2.enqueueToast = function (val, opts) {
      _this2.queue.enqueue(val, opts || _this2.props.optionsFn);
    };

    _this2.queue = new ToastQueue(props);
    _this2.state = {
      toasts: []
    };
    return _this2;
  }

  var _proto = ToastProviderClass.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unsubscribe = this.queue.subscribe(this.onQueueChange);

    if (typeof window !== 'undefined') {
      if (this.props.pauseOnWindowBlur) {
        window.addEventListener('blur', this.onWindowBlur);
      }

      if (this.props.resumeOnWindowFocus) {
        window.addEventListener('focus', this.onWindowFocus);
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }

    if (typeof window !== 'undefined') {
      window.removeEventListener('focus', this.onWindowFocus);
      window.removeEventListener('blur', this.onWindowBlur);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        duration = _this$props.duration,
        maxSize = _this$props.maxSize,
        optionsFn = _this$props.optionsFn,
        pauseOnMouseEnter = _this$props.pauseOnMouseEnter,
        pauseOnWindowBlur = _this$props.pauseOnWindowBlur,
        placement = _this$props.placement,
        portal = _this$props.portal,
        portalContent = _this$props.portalContent,
        resumeOnMouseLeave = _this$props.resumeOnMouseLeave,
        resumeOnWindowFocus = _this$props.resumeOnWindowFocus,
        rest = _objectWithoutProperties(_this$props, _excluded);

    var toasts = this.state.toasts.map(function (toast) {
      var onClose = toast.dismiss;

      if (toast.value.props.onClose) {
        onClose = function onClose() {
          toast.value.props.onClose();
          toast.dismiss();
        };
      }

      return /*#__PURE__*/React.cloneElement(toast.value, {
        key: toast.toastId,
        onClose: onClose,
        onMouseEnter: pauseOnMouseEnter ? toast.pause : undefined,
        onMouseLeave: resumeOnMouseLeave ? toast.resume : undefined
      });
    });
    var toastContent = portalContent({
      toasts: toasts
    });
    var content = /*#__PURE__*/React.createElement("div", _extends({}, rest, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 107,
        columnNumber: 23
      }
    }), toastContent);

    if (portal === true && typeof document !== 'undefined') {
      content = /*#__PURE__*/ReactDOM.createPortal(content, document.body);
    }

    if (portal !== true && portal) {
      content = /*#__PURE__*/ReactDOM.createPortal(content, portal);
    }

    return /*#__PURE__*/React.createElement(ToastContext.Provider, {
      value: this.getContext(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 117,
        columnNumber: 13
      }
    }, children, content);
  };

  return ToastProviderClass;
}(React.Component);
/**
 * `ToastProvider` provides the context for the the `withToast` higher order component.
 * When you wrap your component with `withToast`, your component will be enhanced with the
 * `enqueueToast` prop. This prop can be called with a `Toast` component to be added to the
 * toast queue.
 *
 * It is possible to have multiple providers, but you must be careful with the positions such that
 * they do not overlap. It is recommended that you only have one provider per application.
 */


var ToastProvider = styled(ToastProviderClass).withConfig({
  displayName: "ToastProvider",
  componentId: "sc-ro1hlb-0"
})([""]); // This is a little unusual -- it allows both eslint to validate and styleguidist to parse props.
// eslint-disable-next-line no-multi-assign

ToastProvider.propTypes = ToastProviderClass.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Components that require the `withToast` context need to be children of this component.
   */
  children: PropTypes.node.isRequired,

  /**
   * The default duration in milliseconds to show a toast before automatically dismissing it.
   * Set this to `0` and toasts must manually be dismissed.
   *
   * Note: A `duration` returned by `optionsFn` would take precedence over this.
   */
  duration: PropTypes.number,

  /**
   * The maximum number of toasts visible at once.
   * Set this to `0` to remove the size limit.
   */
  maxSize: PropTypes.number,

  /**
   * An options function allows you to globally customize the options object passed to
   * `enqueueToast`. This is useful for setting a different duration based on other props such as
   * `appearance`.
   */
  optionsFn: PropTypes.func,

  /**
   * By default, toasts are paused when the mouse enters them.
   */
  pauseOnMouseEnter: PropTypes.bool,

  /**
   * By default, all toasts are paused when the window loses focus.
   */
  pauseOnWindowBlur: PropTypes.bool,

  /**
   * Where the toast region will exist with respect to the viewport.
   * e.g. "top-start", "top", "top-end", "bottom-start", "bottom", "bottom-end"
   */
  placement: PropTypes.string,

  /**
   * By default, toasts will be rendered into a Portal in the document body.
   * With this prop, you can specify a different container,
   * or you can disable the portal to render the content inline by passing false.
   */
  portal: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),

  /**
   * A render function for the toast content. By default, toasts will be rendered into an
   * `AnimatedList`. The render function is passed an object with `toasts` as the only property.
   */
  portalContent: PropTypes.func,

  /**
   * By default, toasts are resumed when the mouse leaves them.
   */
  resumeOnMouseLeave: PropTypes.bool,

  /**
   * By default, all toasts are resumed when the window gains focus.
   */
  resumeOnWindowFocus: PropTypes.bool
} : {}; // This is a little unusual -- it allows both eslint to validate and styleguidist to parse props.
// eslint-disable-next-line no-multi-assign

ToastProvider.defaultProps = ToastProviderClass.defaultProps = {
  duration: 5000,
  portal: true,
  maxSize: 3,
  optionsFn: undefined,
  pauseOnMouseEnter: true,
  pauseOnWindowBlur: true,
  placement: undefined,
  // eslint-disable-next-line zillow/react/prop-types
  portalContent: function portalContent(_ref) {
    var toasts = _ref.toasts;
    return /*#__PURE__*/React.createElement(AnimatedList, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 206,
        columnNumber: 36
      }
    }, toasts);
  },
  resumeOnMouseLeave: true,
  resumeOnWindowFocus: true
};
/** @component */

export default ToastProvider;